import React, { useState } from "react";

const TextInput = ({
  label,
  name,
  register,
  error,
  isRequired,
  className = "",
  placeholder,
  type,
  value,
  id,
  hasicon,
  ...rest
}) => {
  const [isShow, setIsShow] = useState(false);

  return (
    <div className=" w-100">
      {label && (
        <label htmlFor={id} className="text-neutral-900 text-sm mb-2 fw-medium">
          {label}
          {isRequired && <span className="text-danger">*</span>}
        </label>
      )}
      {name && (
        <div className="position-relative">
          <input
            type={isShow ? "text" : type}
            className={`${className} common-input`}
            id={id}
            placeholder={placeholder}
            {...register(name)}
            {...rest}
          />
          {hasicon && (
            <div
              className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer"
              onClick={() => setIsShow((prev) => !prev)}
            >
              <span className=" ph ph-eye-slash" />
            </div>
          )}
        </div>
      )}
      {!name && (
        <div className="position-relative">
          <input
            type={isShow ? "text" : type}
            className={`${className} common-input`}
            id={id}
            placeholder={placeholder}
            {...rest}
          />
          {hasicon && (
            <div
              className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer"
              onClick={() => setIsShow((prev) => !prev)}
            >
              <span className=" ph ph-eye-slash" />
            </div>
          )}
        </div>
      )}
      {error && (
        <div className="mt-1">
          <p className="text-danger">{error?.message}</p>
        </div>
      )}
    </div>
  );
};

export default TextInput;
